export enum InteractionName {
  BannerComponentLoad = 'banner-component-load',
  BannerRender = 'banner-render',
  LoadExperiments = 'load-experiments',
  FetchBnplMethods = 'fetch-bnpl-methods',
  FetchBannerSettings = 'fetch-banner-settings',
  ResolveCountry = 'resolve-country',
}
